import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigateToServices = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      const servicesSection = document.getElementById("services");
      if (servicesSection) {
        servicesSection.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const servicesSection = document.getElementById("services");
        if (servicesSection) {
          servicesSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  const handleNavigateToAbout = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      const aboutSection = document.getElementById("about");
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const aboutSection = document.getElementById("about");
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  const handleNavigateToReviews = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      const reviewsSection = document.getElementById("reviews");
      if (reviewsSection) {
        reviewsSection.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const reviewsSection = document.getElementById("reviews");
        if (reviewsSection) {
          reviewsSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  return (
    <footer className="bg-[#0F4C5C] dark:bg-[#06181C] text-white pt-20 pb-8 border-t border-white/10 dark:border-white/5 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 mb-16 text-left">
          
          {/* Left Column: Logo & Clinic Info */}
          <div className="lg:col-span-6 space-y-6">
            <img src="/logos/clinic_logo_light.png" alt="Dr. Krishna's Dental" className="h-16 object-contain" />

            {/* Address */}
            <div>
              <p className="text-xs font-bold text-white/50 uppercase tracking-widest mb-1.5">
                {t.footer.addressLabel}
              </p>
              <a
                href="https://maps.google.com/?cid=9075574088887791861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAMYASAF&hl=en&gl=IN&source=embed"
                target="_blank"
                rel="noreferrer"
                className="text-white/80 hover:text-white text-sm leading-relaxed block transition-colors max-w-sm"
              >
                First Floor, 6-119/3/2,
                <br />
                Dammaiguda Rd, Dattatreya Nagar Colony, Nagaram,
                <br />
                Secunderabad, Telangana 500083
              </a>
            </div>

            {/* Phone */}
            <div>
              <p className="text-xs font-bold text-white/50 uppercase tracking-widest mb-1.5">
                {t.footer.phoneLabel}
              </p>
              <div className="space-y-1">
                <a href="tel:+916281785274" className="text-white/80 hover:text-white text-sm block transition-colors">
                  +91 62817 85274
                </a>
                <a href="tel:+918186871685" className="text-white/80 hover:text-white text-sm block transition-colors">
                  +91 81868 71685
                </a>
              </div>
            </div>

            {/* Timing */}
            <div>
              <p className="text-xs font-bold text-white/50 uppercase tracking-widest mb-1.5">
                {t.footer.timingLabel}
              </p>
              <p className="text-white/80 text-sm">{t.footer.timings}</p>
            </div>

            {/* Social Icons */}
            <div className="flex space-x-3 pt-2">
              <a
                href="https://www.google.com/maps/place/Dr.+Krishna's+Dental+Braces+%26+Implant+center/@17.4905101,78.5994577,17z/data=!3m1!5s0x3bcb9cf07ad9b185:0x83e5f61074131207!4m8!3m7!1s0x3bcb9d64f9c20e93:0x7df2ea8ca4e570f5!8m2!3d17.4905101!4d78.5994577!9m1!1b1!16s%2Fg%2F11wtvyrmxy?hl=en&entry=ttu"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-white hover:text-[#0F4C5C] flex items-center justify-center text-sm transition-all"
                title="Google Maps"
              >
                G
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-white hover:text-[#0F4C5C] flex items-center justify-center text-sm transition-all"
                title="Instagram"
              >
                📷
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-white hover:text-[#0F4C5C] flex items-center justify-center text-sm transition-all"
                title="Facebook"
              >
                f
              </a>
            </div>
          </div>

          {/* Right Column: Navigation Links */}
          <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-8 pt-2">
            {/* Column 1: Our Practice */}
            <div>
              <h4 className="text-sm font-bold text-white mb-4 tracking-wider">
                Our Practice
              </h4>
              <ul className="space-y-3 text-sm text-white/70">
                <li>
                  <a href="/" onClick={handleNavigateToAbout} className="hover:text-white transition-colors">
                    Meet Dr. Sai Krishna
                  </a>
                </li>
                <li>
                  <a href="/" onClick={handleNavigateToAbout} className="hover:text-white transition-colors">
                    Meet Dr. Thejasri
                  </a>
                </li>
                <li>
                  <a href="/" onClick={handleNavigateToAbout} className="hover:text-white transition-colors">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="/" onClick={handleNavigateToReviews} className="hover:text-white transition-colors">
                    Patient Reviews
                  </a>
                </li>
                <li>
                  <Link to="/contact" className="hover:text-white transition-colors">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 2: Services */}
            <div>
              <h4 className="text-sm font-bold text-white mb-4 tracking-wider">
                <a href="/" onClick={handleNavigateToServices} className="hover:underline">
                  Services
                </a>
              </h4>
              <ul className="space-y-3 text-sm text-white/70">
                <li>
                  <a href="/" onClick={handleNavigateToServices} className="hover:text-white transition-colors font-medium text-white/90">
                    All Services &rarr;
                  </a>
                </li>
                <li>
                  <Link to="/services/general-dentistry" className="hover:text-white transition-colors">
                    General Dentistry
                  </Link>
                </li>
                <li>
                  <Link to="/services/cosmetic-dentistry" className="hover:text-white transition-colors">
                    Cosmetic Dentistry
                  </Link>
                </li>
                <li>
                  <Link to="/services/orthodontics" className="hover:text-white transition-colors">
                    Orthodontics
                  </Link>
                </li>
                <li>
                  <Link to="/services/teeth-whitening" className="hover:text-white transition-colors">
                    Teeth Whitening
                  </Link>
                </li>
                <li>
                  <Link to="/services/root-canal-treatment" className="hover:text-white transition-colors">
                    Root Canal Treatment
                  </Link>
                </li>
                <li>
                  <Link to="/services/crowns-bridges" className="hover:text-white transition-colors">
                    Crowns & Bridges
                  </Link>
                </li>
                <li>
                  <Link to="/services/implants" className="hover:text-white transition-colors">
                    Implants
                  </Link>
                </li>
              </ul>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Dr. Krishna's Dental. All rights reserved.</p>
          <div className="flex space-x-6">
            <Link to="/contact" className="hover:text-white transition-colors underline">
              Privacy Policy
            </Link>
            <Link to="/contact" className="hover:text-white transition-colors underline">
              Terms of Use
            </Link>
          </div>
          <p className="text-white/40">Powered by Dr. Krishna's Dental</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
